var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "lc-actions" },
    [
      _c(
        "v-tooltip",
        {
          attrs: { bottom: "" },
          scopedSlots: _vm._u([
            {
              key: "activator",
              fn: function ({ on }) {
                return [
                  _c(
                    "v-btn",
                    _vm._g(
                      {
                        attrs: { icon: "", small: "" },
                        on: {
                          click: function ($event) {
                            $event.stopPropagation()
                            return _vm.$emit("preview", _vm.payslip)
                          },
                        },
                      },
                      on
                    ),
                    [
                      _c("v-icon", { attrs: { small: "", color: "blue" } }, [
                        _vm._v("mdi-file-pdf-box"),
                      ]),
                    ],
                    1
                  ),
                ]
              },
            },
          ]),
        },
        [_c("span", [_vm._v("Ver recibo")])]
      ),
      _c(
        "v-tooltip",
        {
          attrs: { bottom: "" },
          scopedSlots: _vm._u([
            {
              key: "activator",
              fn: function ({ on }) {
                return [
                  _c(
                    "v-btn",
                    _vm._g(
                      {
                        attrs: { icon: "", small: "" },
                        on: {
                          click: function ($event) {
                            $event.stopPropagation()
                            return _vm.$emit("events", _vm.payslip)
                          },
                        },
                      },
                      on
                    ),
                    [
                      _c(
                        "v-icon",
                        { attrs: { small: "", color: "grey darken-1" } },
                        [_vm._v("mdi-history")]
                      ),
                    ],
                    1
                  ),
                ]
              },
            },
          ]),
        },
        [_c("span", [_vm._v("Historial")])]
      ),
      _vm.menuActions.length > 0
        ? _c(
            "v-menu",
            {
              attrs: { "offset-y": "", left: "" },
              scopedSlots: _vm._u(
                [
                  {
                    key: "activator",
                    fn: function ({ on, attrs }) {
                      return [
                        _c(
                          "v-btn",
                          _vm._g(
                            _vm._b(
                              {
                                attrs: { icon: "", small: "" },
                                on: {
                                  click: function ($event) {
                                    $event.stopPropagation()
                                  },
                                },
                              },
                              "v-btn",
                              attrs,
                              false
                            ),
                            on
                          ),
                          [
                            _c(
                              "v-icon",
                              {
                                staticClass: "grey--text text--darken-2",
                                attrs: { small: "" },
                              },
                              [_vm._v("mdi-dots-vertical")]
                            ),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ],
                null,
                false,
                3893873575
              ),
            },
            [
              _c(
                "v-list",
                { attrs: { dense: "" } },
                _vm._l(_vm.menuActions, function (action) {
                  return _c(
                    "v-list-item",
                    {
                      key: action.event,
                      on: {
                        click: function ($event) {
                          return _vm.$emit(action.event, _vm.payslip)
                        },
                      },
                    },
                    [
                      _c(
                        "v-list-item-icon",
                        { staticClass: "mr-3" },
                        [
                          _c(
                            "v-icon",
                            { attrs: { small: "", color: action.color } },
                            [_vm._v(_vm._s(action.icon))]
                          ),
                        ],
                        1
                      ),
                      _c("v-list-item-title", { class: action.text_class }, [
                        _vm._v(_vm._s(action.name)),
                      ]),
                    ],
                    1
                  )
                }),
                1
              ),
            ],
            1
          )
        : _c("span", { staticClass: "actions-spacer" }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }